module.exports = __webpack_public_path__ + "img/icon372.4d85c14f.png";